import ifood from "./logos/ifood-logo-0.png"
import uber_eats from "./logos/uber-eats-logo-0.png"

const logos = {ifood, uber_eats}
export default logos
